<template>
  <font-awesome-icon
    :icon="{ prefix: 'fab', iconName: 'pinterest-p' }" />
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPinterestP } from '@fortawesome/free-brands-svg-icons'

library.add(faPinterestP)

export default {
  name: 'CoozzyPinterestIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-yellow;
  }
</style>
